import React from "react";
import { Box } from "@mui/material";
import Header from "../../components/Header";
import ResidentsTable from "../../components/ResidentsTable";
import { useGetSummaryQuery } from "../../services/resident.service";

// Cumulative residents table: every shift / surgery ever logged.
const ResidentsTotal = () => {
  const { data, isLoading, isError } = useGetSummaryQuery();

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="Ειδικευόμενοι - Σύνολο" subtitle="Συνολικές εφημερίες και χειρουργεία ανά ειδικευόμενο" />
      <ResidentsTable data={data} isLoading={isLoading} isError={isError} />
    </Box>
  );
};

export default ResidentsTotal;
